import type { WorkflowOptions } from '../../types';
import { addContactWorkflow } from './addContactWorkflow';
import { editContactWorkflow } from './editContactWorkflow';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
export const workflows: WorkflowOptions[] = [
  addContactWorkflow,
  editContactWorkflow,
  ...Object.values(generateAssetStatusWorkflow('contact')),
];

export default workflows;
